export const SHOWS = [
  { metaDate: new Date(2023,7,15),
    date: 'JULY 15 2023',
    name:'Farm house at Cooks garden',
    location: 'Venice, CA',
    ticketLink: `https://www.eventbrite.com/e/farm-house-miami-vice-day-party-tickets-664266407707?aff=Furious`}
  ]